export default "__VITE_ASSET__CgJU1800__"